module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("前沿活动")]), _c('div', {
    staticClass: "news-wapper"
  }, _vm._l((_vm.activities), function(item) {
    return _c('article', {
      key: item.id,
      staticClass: "news-item"
    }, [_c('div', {
      staticClass: "banner",
      style: ({
        backgroundImage: 'url(' + item.avatar_url + '?imageView2/1/w/1069/h/620/interlace/1/q/88/interlace/1/)'
      })
    }, [_c('div', {
      staticClass: "activity-type"
    }, [_c('div', {
      staticClass: "en"
    }, [_vm._v("FRONTIER"), _c('br'), _vm._v(_vm._s(item.activity_type))]), _c('div', {
      staticClass: "cn"
    }, [_vm._v(_vm._s(_vm._f("getCN")(item.activity_type)))])])]), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "activity-content"
    }, [_c('h4', [_vm._v(_vm._s(item.title))])]), _c('div', {
      staticClass: "activity-meta"
    }, [(item.article_link) ? _c('a', {
      staticClass: "link",
      attrs: {
        "href": item.article_link,
        "target": "_blank"
      }
    }, [_vm._v("查看")]) : _vm._e(), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.activity_time)))])])])])
  }), 0), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more"
  }, [_c('a', {
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("更多活动 >")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c7e4a75!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events.vue
// module id = 206
// module chunks = 1